(function () {
  'use strict';

  if (window.BBNameBadgeStart) {
    window.BBNameBadgeStart.initAll(document);
    return;
  }

  function initGallery(root) {
    var gallery = root.querySelector('[data-bb-name-badge-gallery]');
    if (!gallery || gallery.dataset.bbNameBadgeGalleryReady === 'true') return;

    var mainButton = gallery.querySelector('[data-bb-name-badge-gallery-main]');
    var mainImage = mainButton && mainButton.querySelector('img');
    var dialog = gallery.querySelector('[data-bb-name-badge-gallery-dialog]');
    var dialogImage = gallery.querySelector('[data-bb-name-badge-gallery-dialog-image]');
    var closeButton = gallery.querySelector('[data-bb-name-badge-gallery-close]');
    var previousButton = gallery.querySelector('[data-bb-name-badge-gallery-prev]');
    var nextButton = gallery.querySelector('[data-bb-name-badge-gallery-next]');
    var viewport = gallery.querySelector('[data-bb-name-badge-gallery-viewport]');
    var viewerIndex = 0;
    var savedBodyOverflow = '';

    function thumbs() {
      return Array.from(gallery.querySelectorAll('[data-bb-name-badge-gallery-thumb]'));
    }

    function selectThumb(thumb) {
      var source = thumb.getAttribute('data-full-src');
      if (!source || !mainImage) return false;

      thumbs().forEach(function (item) {
        var active = item === thumb;
        item.classList.toggle('active', active);
        item.setAttribute('aria-current', active ? 'true' : 'false');
      });
      mainImage.src = source;
      mainImage.removeAttribute('srcset');
      mainImage.alt = thumb.getAttribute('data-full-alt') || '';
      return true;
    }

    function activeIndex() {
      var items = thumbs();
      for (var index = 0; index < items.length; index += 1) {
        if (items[index].getAttribute('aria-current') === 'true') return index;
      }
      return 0;
    }

    function renderViewer(index) {
      var items = thumbs();
      if (!items.length || !dialogImage) return false;

      viewerIndex = (index + items.length) % items.length;
      var thumb = items[viewerIndex];
      var source = thumb.getAttribute('data-zoom-src') || thumb.getAttribute('data-full-src');
      if (!source) return false;

      dialogImage.src = source;
      dialogImage.alt = (thumb.getAttribute('data-full-alt') || 'Name badge') + ' image ' + (viewerIndex + 1) + ' of ' + items.length;
      dialogImage.style.transform = '';
      if (viewport) viewport.classList.remove('is-zoomed');
      if (previousButton) previousButton.hidden = items.length < 2;
      if (nextButton) nextButton.hidden = items.length < 2;
      return true;
    }

    function openViewer() {
      if (!dialog || !renderViewer(activeIndex())) return;
      savedBodyOverflow = document.body ? document.body.style.overflow : '';
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      if (document.body) document.body.style.overflow = 'hidden';
    }

    function closeViewer() {
      if (!dialog) return;
      if (typeof dialog.close === 'function' && dialog.open) dialog.close();
      else {
        dialog.removeAttribute('open');
        dialog.dispatchEvent(new Event('close'));
      }
    }

    gallery.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-bb-name-badge-gallery-thumb]');
      if (thumb && gallery.contains(thumb)) selectThumb(thumb);
    });

    if (mainButton) mainButton.addEventListener('click', openViewer);
    if (closeButton) closeButton.addEventListener('click', closeViewer);
    if (previousButton) previousButton.addEventListener('click', function () { renderViewer(viewerIndex - 1); });
    if (nextButton) nextButton.addEventListener('click', function () { renderViewer(viewerIndex + 1); });

    if (dialog) {
      dialog.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          renderViewer(viewerIndex - 1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          renderViewer(viewerIndex + 1);
        }
      });
      dialog.addEventListener('close', function () {
        if (document.body) document.body.style.overflow = savedBodyOverflow;
        if (viewport) viewport.classList.remove('is-zoomed');
        if (dialogImage) dialogImage.style.transform = '';
        if (mainButton) mainButton.focus();
      });
    }

    if (viewport && dialogImage) {
      viewport.addEventListener('click', function () {
        var zoomed = viewport.classList.toggle('is-zoomed');
        dialogImage.style.transform = zoomed ? 'scale(2)' : '';
      });
    }

    gallery.dataset.bbNameBadgeGalleryReady = 'true';
  }

  function init(root) {
    if (!root) return;

    initGallery(root);
    if (root.dataset.bbNameBadgeStartReady === 'true') return;

    var options = Array.from(root.querySelectorAll('[data-bb-material-option]'));
    if (!options.length) return;

    options.forEach(function (option, index) {
      option.addEventListener('keydown', function (event) {
        var targetIndex = index;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          targetIndex = (index + 1) % options.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          targetIndex = (index - 1 + options.length) % options.length;
        } else if (event.key === 'Home') {
          targetIndex = 0;
        } else if (event.key === 'End') {
          targetIndex = options.length - 1;
        } else if (event.key === ' ') {
          event.preventDefault();
          option.click();
          return;
        } else {
          return;
        }

        event.preventDefault();
        options[targetIndex].focus();
      });
    });

    root.dataset.bbNameBadgeStartReady = 'true';
  }

  function initAll(scope) {
    var target = scope || document;

    if (target.matches && target.matches('[data-bb-name-badge-start]')) {
      init(target);
    }

    if (target.querySelectorAll) {
      target.querySelectorAll('[data-bb-name-badge-start]').forEach(init);
    }
  }

  window.BBNameBadgeStart = {init: init, initAll: initAll};

  initAll();
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initAll(event.target);
  });
})();
